import {
  CronJob,
  CronJobExecution,
  CronJobExecutionLogRow,
  CronJobExecutionRow,
  CronJobExecutionSummary,
} from "./types";

const transformExecutionSummary = (res: any): CronJobExecutionSummary => ({
  id: res.id,
  started: res.started,
  finished: res.finished ?? null,
  status: res.status,
  durationSeconds: res.durationSeconds ?? 0,
});

export const transformCronJob = (res: any): CronJob => ({
  id: res.id,
  name: res.name,
  slug: res.slug,
  description: res.description ?? "",
  status: res.status,
  lastRun: res.lastRun ?? null,
  nextRun: res.nextRun ?? null,
  manualRun: res.manualRun ?? false,
  metadata: res.metadata ?? null,
  canResetStatus: res.canResetStatus ?? false,
  executionCount: res.executionCount ?? 0,
  lastExecution: res.lastExecution ? transformExecutionSummary(res.lastExecution) : null,
});

export const transformCronJobExecutionRow = (res: any): CronJobExecutionRow => ({
  id: res.id,
  cronJobId: res.cronJobId,
  started: res.started,
  finished: res.finished ?? null,
  status: res.status,
  metadata: res.metadata || null,
  durationSeconds: res.durationSeconds ?? 0,
  logCount: res.logCount ?? 0,
});

export const transformCronJobExecution = (res: any): CronJobExecution => ({
  ...transformCronJobExecutionRow(res),
  cronJobName: res.cronJobName ?? null,
  cronJobSlug: res.cronJobSlug ?? null,
});

export const transformCronJobExecutionLogRow = (res: any): CronJobExecutionLogRow => ({
  id: res.id,
  cronJobExecutionId: res.cronJobExecutionId,
  log: res.log ?? "",
  created: res.created,
  updated: res.updated ?? null,
});

/*---------------------------------------------------------------------------------------
    PRIKAZ
-----------------------------------------------------------------------------------------*/

const dateTimeFormat = new Intl.DateTimeFormat("hr-HR", {
  dateStyle: "medium",
  timeStyle: "medium",
});

/** Datum i vrijeme u lokalnoj zoni preglednika; crtica kad vrijednosti nema. */
export const formatCronDateTime = (iso: string | null | undefined): string =>
  iso ? dateTimeFormat.format(new Date(iso)) : "—";

/** `3661` → `1h 01m 01s`; ispod minute samo sekunde. */
export const formatDuration = (totalSeconds: number | null | undefined): string => {
  if (totalSeconds == null || totalSeconds < 0) return "—";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours > 0) {
    return `${hours}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
  }
  return `${seconds}s`;
};
